import React from 'react';
import { FileText, Zap, Baby, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-8 md:py-12 pt-[10px] pb-[10px]" data-id="element-144">
      {/* Decorative stars */}
      <div className="absolute top-20 left-10 w-2 h-2 bg-yellow-400 rounded-full opacity-50 blur-[1px]" data-id="element-145"></div>
      <div className="absolute top-40 right-20 w-3 h-3 bg-yellow-400 rounded-full opacity-30 blur-[2px]" data-id="element-146"></div>

      <div className="max-w-6xl mx-auto text-center" data-id="element-147">
        <div className="inline-flex items-center space-x-2 text-yellow-400 font-serif font-semibold tracking-wider uppercase text-xs mb-4" data-id="element-148">
          <span className="w-8 h-[1px] bg-yellow-400" data-id="element-149"></span>
          <span data-id="element-150">MUNDO PRÁCTICO™</span>
          <span className="w-8 h-[1px] bg-yellow-400" data-id="element-151"></span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-2 md:mb-4 leading-[1.1] break-words" data-id="element-152">
          Imaginá acostar a tu bebé <br className="hidden md:block" data-id="element-153" />y que se
          duerma. Solo. Sin drama.
        </h1>

        <div className="relative max-w-2xl mx-auto px-4 mt-[10px] mb-[10px]" data-id="element-154">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(234,179,8,0.15)_0%,transparent_70%)] rounded-full" data-id="element-155"></div>
          <picture data-id="element-156">
            <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp 1080w" sizes="(max-width: 768px) 90vw, 600px" data-id="element-157" />
            <img src="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp" srcSet="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp 1080w" sizes="(max-width: 768px) 90vw, 600px" alt="MegaPack Noches de Paz" className="relative z-10 w-full max-w-[500px] mx-auto h-auto drop-shadow-2xl mt-[10px] mb-[10px]" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="sync" data-id="element-158" />
          </picture>
        </div>

        <p className="md:text-xl font-serif italic max-w-2xl mx-auto px-4 mt-[10px] mb-[16px] text-[15px] drop-shadow-[0_0_10px_rgba(250,204,21,0.2)] text-[#FFFFFF]" data-id="element-159">
          El sistema paso a paso para padres agotados con bebés de 4 a 24 meses.
          Sin métodos de llanto. Sin improvisar. Sin buscar más a las 3 AM.
        </p>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 md:gap-8 text-gray-100 px-2 mt-[12px] mb-[16px]" data-id="element-160">
          <div className="flex items-center text-[10px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-161">
            <FileText className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-yellow-400" data-id="element-162" />{' '}
            100% PDF
          </div>
          <div className="flex items-center text-[10px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-163">
            <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-yellow-400" data-id="element-164" />{' '}
            Acceso en 5 min
          </div>
          <div className="flex items-center text-[10px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-165">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-yellow-400" data-id="element-166" />{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center text-[10px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-167">
            <CreditCard className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-yellow-400" data-id="element-168" />{' '}
            Mercado Pago
          </div>
        </div>

        <Button href="#plan-premium" className="mb-4 w-full md:w-auto text-base md:text-xl px-6 md:px-10 py-4" data-id="element-169">
          🌙 → QUIERO RECUPERAR MIS NOCHES
        </Button>
        <div className="flex items-center justify-center space-x-4 text-xs md:text-sm text-gray-200 mb-6" data-id="element-170">
          <span className="flex items-center" data-id="element-171">
            <Lock className="w-4 h-4 mr-1" data-id="element-172" /> Pago seguro
          </span>
          <span data-id="element-173">|</span>
          <span className="flex items-center" data-id="element-174">
            <CreditCard className="w-4 h-4 mr-1" data-id="element-175" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
};